import { courseItemRowSizingCls } from '@pm2/course-builder';
import { useUserIdentityState } from '@provider/user-identity';
import { Row, SortableColumnHeading } from '@ui/kit';
import { SortCoursesBy } from '../hooks/sorted-courses.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ComplexHeader(props) {
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsxs(Row, {
    as: "header",
    sizingCls: courseItemRowSizingCls,
    children: [/*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === SortCoursesBy.TITLE,
      direction: props.options.direction,
      onSort: () => props.applySort(SortCoursesBy.TITLE),
      children: "Titel"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === SortCoursesBy.MODIFIED_AT,
      direction: props.options.direction,
      onSort: () => props.applySort(SortCoursesBy.MODIFIED_AT),
      children: "Sidst \xE6ndret"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === SortCoursesBy.LEVEL,
      direction: props.options.direction,
      onSort: () => props.applySort(SortCoursesBy.LEVEL),
      children: "Niveau"
    }), /*#__PURE__*/jsx(SortableColumnHeading, {
      active: props.options.sortBy === SortCoursesBy.SUBJECT,
      direction: props.options.direction,
      onSort: () => props.applySort(SortCoursesBy.SUBJECT),
      children: "Fag"
    }), user?.role === "teacher" && /*#__PURE__*/jsx("span", {
      role: "columnheader",
      "aria-label": "Actions"
    })]
  });
}

export { ComplexHeader };
//# sourceMappingURL=course-table.header.complex.js.map
